/** @format */

const AbstractWS = require("./AbstractWS");

function LeaveWS(viewModel) {
  var self = this;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  this.method("POST");
  this.name = "LeaveWS";
  self.queueId = null;

  self.serviceURL = function () {
    return "/qless/api/v1/employee/queue" + self.queueId + "/leave";
  };

  self.processData = function (data) {
    var errMsg = null;

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data, false);

    if (self.err) {
      var vm = self.parent;
      vm.conlog(self.err);
      errMsg = self.errorMessage();
      vm.conlog(errMsg);
      vm.errorMessage(errMsg);
      vm.showError(true);
    }
  };

  this.removeSession = function (queueId, sessionId) {
    this.queueId = queueId;
    this.addParam('sessionId', sessionId);
    this.doRequest(null, null, function () {
      self.queueId = null;
      self.clearParams();
    });
  }

  return self;
}

Object.setPrototypeOf(LeaveWS.prototype, AbstractWS.prototype);

module.exports = LeaveWS;
